@if (standalonePage()) {
  <router-outlet />
} @else if (!hideNavbar) {
  <div class="relative flex h-dvh flex-col">
    @if (busy()) {
      <hlm-progress class="absolute inset-x-0 top-0 z-50 h-0.5 rounded-none bg-transparent" aria-label="Loading" data-cy="busy-indicator">
        <hlm-progress-indicator />
      </hlm-progress>
    }
    @if (!focusPage()) {
      <app-header />
    }
    <main class="min-h-0 flex-1 overflow-y-auto">
      <router-outlet />
    </main>
  </div>
}

<hlm-toaster [theme]="colorScheme()" position="bottom-center" richColors closeButton class="whitespace-pre-line" />
